import { Loading } from "@components/common/Loading";
import AssesmentForm from "@components/ui/offer-assesment/assesment-form";
import AssessmentNotEligible from "@components/ui/offer-assesment/assesment-not-eligible/AssesmentNotEligible";
import AssesmentSuccess from "@components/ui/offer-assesment/assesment-success";
import { Box } from "@mui/material";
import eligibleForAssessment from "@services/api/offer-applicant/eligibleForAssessment/eligibleForAssessment";
import { getByOfferApplicantBuilderId } from "@services/api/offer-applicant/getByOfferApplicantBuilderId/getByOfferApplicantBuilderId";
import { getOfferAssesmentQuestions } from "@services/api/offer-assesment/getQuestions/getQuestions";
import { submitOfferAssessment } from "@services/api/offer-assesment/submitAssessment/submitAssessment";
import { getByOfferBuilderId } from "@services/api/offer/getByOfferBuilderId/getByOfferBuilderId";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import type { OfferApplicantEligibilityStatus } from "src/types/ApplicantAssesmentEligibility.interface";

const MAIN_DARK_BG = "#0b0f17";

const AssesmentPage = () => {
  const [searchParams] = useSearchParams();

  const applicantId = searchParams.get("a"); // "1485"
  const offerId = searchParams.get("o"); // "1449"

  const [questions, setQuestions] = useState<any[]>([]);
  const [offer, setOffer] = useState<any>(null);
  const [eligibilityStatus, setEligibilityStatus] =
    useState<OfferApplicantEligibilityStatus | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [isSubmitted, setIsSubmitted] = useState<boolean>(false);

  useEffect(() => {
    const fetchAssesmentQuestions = async () => {
      setLoading(true);
      if (offerId && applicantId) {
        const offer = await getByOfferBuilderId({ id: parseInt(offerId, 10) });
        const offerApplicant = await getByOfferApplicantBuilderId({ id: Number(applicantId) });
        const response = await getOfferAssesmentQuestions(offer?.data?.id);
        const eligibilityStatusResponse = await eligibleForAssessment(
          parseInt(offerApplicant?.data?.id, 10)
        );
        setEligibilityStatus(eligibilityStatusResponse.data?.eligible || null);
        setOffer({
          title:
            offer.data?.title || "",
          company:
            offer.data?.company_name || "",
        });
        setQuestions(
          response.data || []
        );
      }
      setLoading(false);
    };
    fetchAssesmentQuestions();
  }, [applicantId, offerId]);

  const handleSubmitAssessment = async (answers: Record<string, string>) => {
    const response = await submitOfferAssessment(
      Number(offerId),
      Number(applicantId),
      answers
    );
    if (response.data?.isSubmitted) {
      setIsSubmitted(true);
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        width: "100%",
        bgcolor: MAIN_DARK_BG,
        background: `radial-gradient(circle at 50% 0%, #161d2b 0%, ${MAIN_DARK_BG} 70%)`,
        py: { xs: 4, sm: 6 },
        boxSizing: "border-box",
      }}
    >
      {loading && <Loading />}

      {!loading && !isSubmitted && eligibilityStatus === "ELIGIBLE" && (
        <AssesmentForm
          offer={offer}
          questions={questions}
          onSubmit={handleSubmitAssessment}
        />
      )}

      {!loading &&
        (isSubmitted ||
          eligibilityStatus === "ALREADY_ANSWERED" ||
          eligibilityStatus === "NOT_SHORTLISTED") && <AssesmentSuccess />}

      {!loading && eligibilityStatus === null && <AssessmentNotEligible />}
    </Box>
  );
};

export default AssesmentPage;